import { CITY_4334 } from "../../constants";
import {
	USER_ADDRESS,
	SET_DEFAULT_ADDRESS,
	USER_DOCUMENTS,
	UPDATE_USER_DOCUMENT,
	USER_VECHICLES,
	LOGOUT_SUCCESS,
	UPDATE_USER_VEHICLE,
	USER_MAP_ADDRESS,
	USER_CUR_LAT_LONG,
	UPDATE_VEHICLE_DEFAULT_ADDRESS,
	DELETE_VEHICLE,
	DELETE_ADDRESS,
	STORE_CITY_STATE,
	EDIT_ADDRESS_ID,
	EDIT_USER_ADDRESS,
	GET_RECOMMENDED_SERVICES_SUCCESS,
	FORM_CAR_SLIDE_DATA,
	WITH_SEARCH_RECOMMENDATIONS_SUCCESS,
	GET_FAQS_SUCCESS,
	SAVE_SEARCH_SERVICE_DATA,
	SAVE_CATELOG_VEHICLE_ID,
	SAVE_ADDRESS_DID_REF,
	GET_SERVICE_DETAILS_SUCCESS,
	SAVE_LOCATION_STATUS,
	SAVE_USER_VEHICLES,
	GET_USER_REFERAL_DETAILS_SUCCESS,
	GET_VEHICLE_IMAGE_SUCCESS,
	GET_APP_VERSIONS_SUCCESS,
} from "../Types";

const initalState = {
	userAddressList: [],
	userDocumentsList: [],
	userVehiclesList: [],
	map_address: "",
	curLat: 17.4477736,
	curLong: 78.3677646,
	storeCity: "",
	storeState: "",
	recommendedServices: [],
	recommendedTags: [],
	carSlidesData: [],
	searchRecommendations: [],
	searchServices: [],
	searchTags: [],
	FaqList: [],
	serviceSearch: "",
	sliderCatelogVehicleId: "",
	selectedAddressRef: "",
	servicesDetails: {},
	locationStatus: "",
	referalDetails: [],
	serviceSearchTags: [],
};

export function userReducer(state = initalState, action) {
	switch (action.type) {
		case USER_ADDRESS: {
			return {
				...state,
				userAddressList: [...state.userAddressList, ...action.data],
			};
		}
		case STORE_CITY_STATE: {
			const { cityFetched, stateFetched, pincode } = action.data;
			return {
				...state,
				storeCity: cityFetched,
				storeState: stateFetched,
				storePincode: pincode,
			};
		}
		case USER_DOCUMENTS: {
			return {
				...state,
				userDocumentsList: [...state.userDocumentsList, ...action.data],
			};
		}
		case SAVE_USER_VEHICLES: {
			return {
				...state,
				userVehiclesList: action.data,
			};
		}
		case USER_VECHICLES: {
			return {
				...state,
				userVehiclesList:
					action.operationType === "dont_merge"
						? [...action.data]
						: [...state.userVehiclesList, ...action.data],
			};
		}
		case UPDATE_USER_VEHICLE: {
			const { id } = action;
			return {
				...state,
				userVehiclesList: state.userVehiclesList.map((ele) => {
					if (ele.did === id) {
						return { ...ele, documentIds: [...ele.documentIds, action.data] };
					}
					return ele;
				}),
			};
		}
		case UPDATE_VEHICLE_DEFAULT_ADDRESS: {
			return {
				...state,
				userVehiclesList: state.userVehiclesList.map((ele) => {
					if (ele.did === action.data.did) {
						return action.data;
					}
					return ele;
				}),
			};
		}
		case DELETE_VEHICLE: {
			const deletingItem = state.userVehiclesList.find(
				(item) => item.did === action.data
			);
			if (deletingItem.documentIds.length) {
				var filteredDocs = state.userDocumentsList.filter((ele) => {
					const ids = deletingItem.documentIds.map((val) => val.split("/").pop());
					return !ids.includes(ele.did);
				});
			}

			if (deletingItem.documentIds.length) {
				return {
					...state,
					userVehiclesList: state.userVehiclesList.filter((ele) => {
						return ele.did !== action.data;
					}),
					userDocumentsList: filteredDocs,
				};
			} else {
				return {
					...state,
					userVehiclesList: state.userVehiclesList.filter((ele) => {
						return ele.did !== action.data;
					}),
				};
			}
		}
		case DELETE_ADDRESS: {
			return {
				...state,
				userAddressList: state.userAddressList.filter((ele) => {
					return ele.did !== action.data;
				}),
			};
		}
		case UPDATE_USER_DOCUMENT: {
			const { did } = action.data;
			return {
				...state,
				userDocumentsList: state.userDocumentsList.map((ele) => {
					if (ele.did === did) {
						return action.data;
					}
					return ele;
				}),
			};
		}
		case LOGOUT_SUCCESS: {
			return {
				...initalState,
			};
		}
		case USER_MAP_ADDRESS: {
			const { map_address } = action;
			return {
				...state,
				map_address: map_address,
			};
		}
		case USER_CUR_LAT_LONG: {
			const { curLat, curLong } = action;
			return {
				...state,
				curLat: curLat,
				curLong: curLong,
			};
		}
		case EDIT_ADDRESS_ID: {
			return {
				...state,
				edit_address_id: action.id,
			};
		}
		case EDIT_USER_ADDRESS: {
			const { edit_add } = action;
			return {
				...state,
				userAddressList: state.userAddressList.map((ele) => {
					if (ele.did === edit_add.did) {
						return edit_add;
					} else {
						return ele;
					}
				}),
			};
		}
		// case GET_RECOMMENDED_SERVICES_SUCCESS: {
		//   const { body } = action;
		//   const { recommendedServices, tags } = body;
		//   return {
		//     ...state,
		//     recommendedServices: recommendedServices,
		//     recommendedTags: tags,
		//   };
		// }
		case FORM_CAR_SLIDE_DATA: {
			const { model_data, vehicle_list } = action;
			const carSlide = [];
			model_data.map((model, ind) => {
				vehicle_list.map((vehicle, index) => {
					if (model.make === vehicle.make && model.name === vehicle.model) {
						carSlide.push({ ...vehicle, carUrl: model.imageUrl });
						return {};
					}
				});
			});
			return { ...state, carSlidesData: carSlide };
		}
		case GET_RECOMMENDED_SERVICES_SUCCESS: {
			const { data } = action.body;
			if (data.length) {
				const obj = data[0];
				const { recommended_services = [], services = [], tags = [] } = obj;
				return {
					...state,
					searchRecommendations: recommended_services,
					searchServices: services,
					searchTags: [...tags, "Body Panel"],
				};
			} else {
				return {
					...state,
					searchRecommendations: [],
					searchServices: [],
					searchTags: ["Body Panel"],
				};
			}
		}
		case GET_FAQS_SUCCESS: {
			return { ...state, FaqList: action.body.data };
		}
		case SAVE_SEARCH_SERVICE_DATA: {
			return {
				...state,
				serviceSearch: action.data.searchString || "",
				serviceSearchTags: action.data.tags || [],
			};
		}
		case SAVE_CATELOG_VEHICLE_ID: {
			return {
				...state,
				sliderCatelogVehicleId: action.data,
			};
		}
		case SAVE_ADDRESS_DID_REF: {
			const { addressDid } = action;
			return {
				...state,
				selectedAddressRef: addressDid,
			};
		}
		case GET_SERVICE_DETAILS_SUCCESS: {
			const { data = [] } = action.body;
			const obj = data.pop();
			return {
				...state,
				servicesDetails: obj,
			};
		}
		case SAVE_LOCATION_STATUS: {
			return { ...state, locationStatus: action.locStatus };
		}
		case GET_USER_REFERAL_DETAILS_SUCCESS: {
			return {
				...state,
				referalDetails: action.body.data,
			};
		}
		case GET_VEHICLE_IMAGE_SUCCESS: {
			// console.log("311 --- ", action);
			return {
				...state,
				vehicleImages: action.body,
			};
		}
		case GET_APP_VERSIONS_SUCCESS: {
			// console.log("GET_APP_VERSIONS_SUCCESS =====", action.body);
			return {
				...state,
				StoreAppVersions: action.body,
			};
		}
		default:
			return state;
	}
}
